import styled, { css } from 'styled-components';
import { ColorAdvice2, ColorAdvice5, Spacing16, Spacing24, Spacing40, Spacing56 } from 'autogen/design-tokens/tokens';
import type { ProductRegimeModel } from 'autogen/swagger/all';
import { breakpoint, sizes } from 'variables';
import Regime from './components/Regime';
import RegimeEntries from './components/RegimeEntries';
import RegimeInformation from './components/RegimeInformation';
import stripes, { type IMatasStripes } from './shared/styles';

/* #region  styles */

const LayoutContainer = styled.div<IMatasStripes>`
    background-color: ${ColorAdvice5};
    display: flex;
    flex-direction: column;
    margin: auto;
    padding: ${Spacing24} ${Spacing16} ${Spacing40};
    min-width: 0;
    max-width: 100%;
    ${stripes}

    & > :first-child {
        margin-bottom: ${Spacing24};
    }

    ${breakpoint.up(sizes.md)} {
        flex-direction: row;

        & > :first-child {
            margin-bottom: unset;
        }
    }

    ${breakpoint.up(sizes.lg)} {
        padding: ${Spacing40} ${Spacing40} ${Spacing56} ${Spacing40};
    }
`;
/* #endregion */

export default function ProductRegime({ model }: { model: ProductRegimeModel }) {
    const information = { advisor: model.advisor, introText: model.productRegimeIntroText };

    return (
        <LayoutContainer position="bottom" stripeHeight="16px" stripeColor1={ColorAdvice2}>
            <Regime model={model}>
                <RegimeInformation information={information} />
                <RegimeEntries />
            </Regime>
        </LayoutContainer>
    );
}
